<mat-button-toggle-group
  (change)="onTypeChange($event)"
  name="fontStyle"
  [(ngModel)]="selectedType"
  aria-label="Font Style"
>
  <mat-button-toggle class="filter-item" value="2">
    <mat-icon class="mr-2">wifitetheringicon</mat-icon>
    Online
  </mat-button-toggle>
  <mat-button-toggle class="filter-item" value="1">
    <mat-icon class="mr-2">point_of_sale</mat-icon>
    POS</mat-button-toggle
  >
</mat-button-toggle-group>
